<template>
    <div>
        <label for="payment-method">{{ t('receivePaymentsTo') }} <span v-if="!showDefault" class="text-danger">*</span> </label>
        <b-form-group>
        <v-select
            v-model="paymentMethod"
            :options="paymentMethods"
            input-id="payment-method"
            class="payment-selector m-0"
            :clearable="false"
            @option:selected="sendPaymentMethod"
            :selectable="(option) => option.value != '' && !option.disabled"
            >
                <template slot="option" slot-scope="option">
                    <div class="d-flex">
                        <div class="pr-1">
                            <img :src="option.avatar" width="30" />
                        </div>
                        <div class="w-100">
                            <div>
                                {{ option.label }}
                            </div>
                            <small>
                                {{ option.amount }}
                            </small>
                            <div>
                                <small v-if="showDisableAccount && option.disabled" class="text-danger">
                                    {{ $t('disableAutomaticSettlementToTransferFromThisAccount') }}
                                </small>
                            </div>
                        </div>
                    </div>
                </template>
                <template #no-options>
                    <div>
                        {{ t('noAccountFound') }}
                    </div>
                </template>
            </v-select>
        </b-form-group>
        <div class="text-right text-primary cursor-pointer" v-if="showReset"><span @click="init">{{ $t('refresh')}} </span></div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import { useUtils as useI18nUtils } from '@core/libs/i18n'
    import commonApi from '@/services/api';
    import Ripple from 'vue-ripple-directive'
    import Utils from '@/utils/index'

export default {
    name: 'ReceivePayments',
    components:{
        vSelect,
        Ripple
    },
    props:{
        account: {
            type: String,
            default: ''
        },
        showDefault: {
            type: Boolean,
            default: false
        },
        showDisableAccount: {
            type: Boolean,
            default: false
        },
        disableAccountKey: {
            type: String,
            default: ''
        },
        accounts:{
            type: Array,
            default(){ return [] }
        }
    },
    data (){
        return{
            showReset: false,
            url: `${location.protocol}//${location.host}/`,
            link: commonApi.baseUrl + '/fapi/',
            paymentMethod: '',
            paymentMethods: [],
        }
    },
    watch: {
        // account: function(data){
        //     this.paymentMethod = {value:data, label:''};
        // },
    },
    mounted(){
       this.init();
    },
    methods: {
        init(){
            if(!this.accounts.length){
                commonApi.paymentAccounts('pageSize=50').then(res=>{
                    if(res.success && res.data.list.length){
                        this.parseAccounts(res.data.list);
                    }
                }).catch(err=>{
                    console.log(err);
                })
            }else{
                this.parseAccounts(this.accounts)
            }
        },
        sendPaymentMethod(e){
            this.$emit('payment-method', {receivingAccountId: e.value, currencyCode: e.currencyCode});
            return e;
        },
        parseAccounts(accounts = []){
            if(this.showDefault){
                this.paymentMethods = [{
                    label: this.$t('defaultSettings'),
                    value: null,
                    avatar: this.url + 'logo.png',
                }];
            }
            this.paymentMethods.push(...accounts.map(method=>{
                const m = {};
                if(method.type == 1 && !method.name) m.label = method.typeText;
                else{
                    m.label = method.name || this.$t('noName');
                }
                if(this.showDisableAccount && this.disableAccountKey){
                    m.disabled = method[this.disableAccountKey] ||  false;
                }
                m.value = method._id;
                m.currencyCode = method.currencyCode;
                m.avatar = method.avatarUrl? method.avatarUrl: this.url + 'logo.png';
                m.amount = Utils.formatCurrency(method.balanceAmount, method.currencyCode) + ` ${method.currencyCode}`;
                return m;
            }));
            const paymentMethod = this.paymentMethods.find(e=> e.value == this.account)
            if(paymentMethod && !paymentMethod.disabled){
                this.paymentMethod = paymentMethod;
            }
            else if(this.paymentMethods && !this.paymentMethods.length){
                this.paymentMethods.push({label: this.$t('noAccountFound'), value: ''});
                this.paymentAccount = this.paymentMethods[0];
                this.showReset = true;
            }
            // if(this.account.length){
            //     const pm = this.paymentMethods.find(e=> e.value == this.account)
            //     if(pm){
            //         this.paymentMethod = pm;
            //     }
            // }
        }
    },
    setup(props) {
    const { t } = useI18nUtils()

    return {
      // i18n
      t,
     }
  }
}
</script>

<style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-select.scss';
    .form-group{
        margin: 0px !important;
    }
</style>